import { render, staticRenderFns } from "./CustomerServiceContent.vue?vue&type=template&id=58a1d554&scoped=true"
import script from "./CustomerServiceContent.vue?vue&type=script&lang=js"
export * from "./CustomerServiceContent.vue?vue&type=script&lang=js"
import style0 from "./CustomerServiceContent.vue?vue&type=style&index=0&id=58a1d554&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a1d554",
  null
  
)

export default component.exports